<h1 mat-dialog-title>Firma de Documentos</h1>
<div mat-dialog-content>
  <form [formGroup]="firmaDocumentosForm">

    <p style="color: black; font-weight: bold">Escoja una o más opciones:</p><br>

    <mat-checkbox formControlName="mandato">Mandato</mat-checkbox>
    <mat-checkbox formControlName="poder" style="margin-left: 16px">Poder</mat-checkbox>
    <br><br>

    <div class="row">
      <mat-form-field appearance="outline" class="col-lg-8 col-md-8 col-sm-12">
        <mat-label>Trámite relacionado</mat-label>
        <select matInput matNativeControl formControlName="tramiteRelacionado" required>
          <option value="" label="--Seleccionar--"></option>
          <option value="MATRICULACION">Matriculación</option>
          <option value="MATRICULACION USADO IMPORTACION">Matriculación usado importación</option>
          <option value="CAMBIO DE PROPIEDAD">Cambio de propiedad</option>
          <option value="DOBLE TRANSFERENCIA">Doble transferencia</option>
          <option value="BAJA TEMPORAL VOLUNTARIA">Baja temporal voluntaria</option>
          <option value="BAJA EXPORTACION">Baja exportación</option>
          <option value="JUSTIFICANTE">Justificante profesional</option>
          <option value="DISTINTIVO AMBIENTAL">Distintivo medioambiental</option>
          <option value="INFORME DE TRAFICO">Informe de tráfico</option>
        </select>
      </mat-form-field>
    </div>

    <div class="row">
      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>Número de pedido</mat-label>
        <input matInput matNativeControl type="text"
               formControlName="numPedido">
      </mat-form-field>
    </div>

  </form>

</div>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button mat-button [disabled]="firmaDocumentosForm.invalid" [mat-dialog-close]="firmaDocumentosForm">Siguiente</button>
</mat-dialog-actions>
